/* eslint-disable max-len */
/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_PRO_STORE } from '@moderntribe/events-pro/data/prefix';

export const ADD_RULE_FIELD = `${ PREFIX_EVENTS_PRO_STORE }/ADD_RULE_FIELD`;
export const ADD_RULE = `${ PREFIX_EVENTS_PRO_STORE }/ADD_RULE`;
export const REMOVE_RULE_FIELD = `${ PREFIX_EVENTS_PRO_STORE }/REMOVE_RULE_FIELD`;
export const REMOVE_RULE = `${ PREFIX_EVENTS_PRO_STORE }/REMOVE_RULE`;
export const EDIT_RULE = `${ PREFIX_EVENTS_PRO_STORE }/EDIT_RULE`;
export const SYNC_RULES_FROM_DB = `${ PREFIX_EVENTS_PRO_STORE }/SYNC_RULES_FROM_DB`;
